import { render, staticRenderFns } from "./kapcsandy-winery.vue?vue&type=template&id=bdab1f24&scoped=true"
import script from "./kapcsandy-winery.vue?vue&type=script&lang=js"
export * from "./kapcsandy-winery.vue?vue&type=script&lang=js"
import style0 from "./kapcsandy-winery.vue?vue&type=style&index=0&id=bdab1f24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdab1f24",
  null
  
)

export default component.exports